import { render, staticRenderFns } from "./AllowlistMinting.vue?vue&type=template&id=6728a2be&"
import script from "./AllowlistMinting.vue?vue&type=script&lang=js&"
export * from "./AllowlistMinting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports